import { useCallback } from 'react';

import { Button, Skeleton } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { soNguyen } from '../../chung/nghiep-vu/so-thong-ke';

/** Lượt tải bắt đầu TRƯỚC khi thấy đáy: cuộn tới chỗ trống rồi mới chờ mạng là cách làm người ta tưởng danh sách đã hết. */
const RONG_MARGIN = '240px';

/**
 * Chân của một danh sách cuộn vô hạn — port `vet/ChanDanhSach.tsx` native: mốc cho `IntersectionObserver` + một nút
 * THẬT. Danh sách chỉ nạp thêm khi mốc lọt vào khung nhìn thì người dùng bàn phím và trình đọc màn hình không có đường
 * nào lấy thêm dữ liệu.
 *
 * Khác native: quan sát gắn qua ref callback (React 19 nhận hàm dọn trả về) thay vì `useEffect`.
 */
export function ChanDanhSach({
  coTrangTiep,
  dangTai,
  onTaiThem,
  soDong,
  ghiChu,
}: {
  coTrangTiep: boolean;
  dangTai: boolean;
  onTaiThem: () => void;
  soDong: number;
  /** Câu thay cho "đã hiện hết" khi danh sách cố ý chỉ có một trang. */
  ghiChu?: string;
}) {
  const { t, locale } = useT();

  const moc = useCallback(
    (nut: HTMLDivElement | null) => {
      if (!nut || !coTrangTiep || typeof IntersectionObserver === 'undefined') return;
      const quanSat = new IntersectionObserver(
        (muc) => {
          if (!dangTai && muc.some((m) => m.isIntersecting)) onTaiThem();
        },
        { rootMargin: RONG_MARGIN },
      );
      quanSat.observe(nut);
      return () => quanSat.disconnect();
    },
    [coTrangTiep, dangTai, onTaiThem],
  );

  return (
    <div ref={moc} className="flex flex-col items-center gap-2 p-4">
      {dangTai ? (
        <Skeleton className="h-8 w-40" />
      ) : coTrangTiep ? (
        <Button variant="outline" size="sm" onClick={onTaiThem}>
          {t('nktv.trangThai.taiThem')}
        </Button>
      ) : soDong > 0 ? (
        <p className="text-center text-xs text-content-muted" role="status">
          {ghiChu ?? t('nktvSuDungAi.danhSach.het', { so: soNguyen(soDong, locale) })}
        </p>
      ) : null}
    </div>
  );
}
